<template>
  <div>
    <Breadcrumb :options="breadcrumb" />
    
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="add" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template slot="detail" slot-scope="scope">
        <div class="detail" @click="goDetail(scope.params.id)">
          点此维护
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import { mapState, mapMutations } from "vuex";

export default {
  mixins: [tableMixin],
  data() {
    return {
      breadcrumb: [
        { name: "客户管理" },
        { name: "客户列表" },
      ],
      baseUrl: 'custom',
      formInline: {},
      formCtrl: [
        {
          label: "车队长",
          keyName: "fleet",
          placeholder: "选择车队长",
          type: "select",
          options: [],
          className: "carcap",
        },
        {
          label: "公司名称",
          keyName: "pname",
          placeholder: "请填写公司名称",
          type: "text",
        },
        {
          label: "联系人",
          keyName: "member",
          placeholder: "请填写联系人",
          type: "text",
        },

      ],
      cols: [
        { prop: "name", label: "公司名称" },
        { prop: "member", label: "联系人" },
        { prop: "phone", label: "联系电话" },
        { prop: "address", label: "联系地址" },
        { prop: "industry", label: "所属行业" },
        { prop: "product", label: "主营产品" },
        { prop: "fleetname", label: "所属车队长" },
        { prop: "addname", label: "添加人" },
        { prop: "detail", label: "维护记录", slot: 'detail' },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/customer/edit?id=${id}&mode=edit`
            );
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
      // baseParams: ['fleet'],
      team: [],
    };
  },
  computed: {
    ...mapState([
      'store'
    ]),
  },
  methods: {
    ...mapMutations([
      'setState'
    ]),

    delParamsPackage(params) {
      params['headers'] = {
        'X-Method': 'delete',
        'X-Module': 'custom',
      }

      // console.log('params', { ...params })
    },

    goDetail(id) {
      this.$router.push(
        `/customer/view?id=${id}`
      );
    },
    getData() {
      this.loading = true
      // this.tabData = [];
      let url = `${this.baseUrl}/index`;
      const params = {
        // userid: this.user.id,
      }
      // console.log(url, params)
      this.post(url, params, ({ team }) => {
        this.loading = false
        console.log(team)
        this.team = team
        this.formCtrl.map(v => {
          if (v.keyName === 'fleet') {
            v.options = team.map(val => {
              return {
                label: val.nickname,
                value: val.id,
              }
            })
          }
        })
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    add() {
      this.$router.push(
        `/customer/detail?mode=add`
      );
    },
  },
  mounted() {
    this.getData()
    this.getFleet();
  },
};
</script>

<style lang="less" scoped>
/deep/.detail {
  font-size: 14px;
  font-weight: 400;
  color: #2691FF;
  cursor: pointer;
}
</style>